"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("bootstrap/dist/css/bootstrap.min.css");
require("bootstrap/dist/js/bootstrap.min.js");
var _index = _interopRequireDefault(require("../GuidesCard/index"));
var _reactBootstrap = require("react-bootstrap");
var _indexModule = _interopRequireDefault(require("./index.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function MortgageGuides(_ref) {
  let {
    basePath,
    openGuidesInNewTab
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.hero_image
  }, /*#__PURE__*/_react.default.createElement("h1", null, " Our Mortgage Guides "))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: _indexModule.default.pageContainer
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'buying-a-home',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/buying-guide.jpg",
    imageAltText: "Buying A Home",
    cardTitle: "Buying A Home",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'refinancing-guide',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/refinancing-guide.jpg",
    imageAltText: "Refinancing",
    cardTitle: "Refinancing",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'investment-property',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/investmentbubble.jpg",
    imageAltText: "Investment Property",
    cardTitle: "Investment Property",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab
    // overlayPresent={true}
    ,
    routePath: basePath + 'vacation-home',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/vacationbubble.jpg",
    imageAltText: "Vacation Home",
    cardTitle: "Vacation Home",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'renting-vs-buying',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/rentvsbuy.jpg",
    imageAltText: "Renting vs Buying",
    cardTitle: "Renting vs Buying",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'biweekly-payment',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/BiweeklyPayments.jpg",
    imageAltText: "Biweekly Payments",
    cardTitle: "Biweekly Payments",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'home-buyers-education',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/buyersedu.jpg",
    imageAltText: "Home Buyers Education",
    cardTitle: "Home Buyers Education",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'down-payment-assistance',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/downpayment.jpg",
    imageAltText: "Down Payment",
    cardTitle: "Down Payment",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'mortgage-process',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/process.jpg",
    imageAltText: "Mortgage Process",
    cardTitle: "Mortgage Process",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'cashout-refinance',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/Cash-OutRefinance.jpg",
    imageAltText: "Cash-Out Refinance",
    cardTitle: "Cash-Out Refinance",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'pre-qualification-and-pre-approval',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/eva.jpg",
    imageAltText: "Pre Qualification and Pre-Approval",
    cardTitle: "Pre Qualification and Pre-Approval",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    guidesPage: openGuidesInNewTab,
    routePath: basePath + 'skipped-payments',
    imageUrl: "https://www.sunwestmortgage.com/swmc-images/guides-images/SkippedPayments.jpg",
    imageAltText: "Skipped Payments",
    cardTitle: "Skipped Payments",
    buttonArray: [{
      buttonText: 'Read More'
    }]
  })))));
}
var _default = exports.default = MortgageGuides;